export enum SYNC_EVENT_BUS_ACTIONS {
  CHANGE_STATUS = "SYNC_EVENT_BUS_ACTIONS.CHANGE_STATUS",
}
